import React, { createContext, FC } from 'react'

import { RejectionTemplateResponse, RejectCandidatePayload, RejectCandidateResponse } from '../../hooks/useRejectCandidates'
import { ChangeStatusPayload, ChangeStatusResponse, GetChangeStatusStatesResponse } from '../../hooks/useChangeStatus'

interface ResponseXHR<T> {
    data: T
    status: number
}

interface SendCandidateBulkMessagePayload {
    attachmentList: Array<string>
    content: string
    entityIdList: Array<string>
    locale: string
    sendAnonymously: boolean
    subject: string
}

interface SendCandidateBulkMessageResponse {
    msgInfo: number
}

interface SendCandidateNotePayload {
    attachmentList: Array<string>
    content: string
    entityIdList: Array<string>
    includeResume: boolean
    locale: string
    subject: string
    toList: Array<string>
}

interface SendCandidateNoteResponse {
    msgInfo: number
}

interface GetChangeStatusPayload {

}

interface CandidateServiceMock {
    rejectCandidateDetailsBulk?: (applicationEIds: any, s: any, callback: (response: ResponseXHR<RejectionTemplateResponse>) => void) => void
    rejectCandidate?: (data: RejectCandidatePayload, callback: (response: ResponseXHR<RejectCandidateResponse>) => void) => void
    sendMessage?: (data: SendCandidateBulkMessagePayload, callback: (response: ResponseXHR<SendCandidateBulkMessageResponse>) => void) => void
    sendNote?: (data: SendCandidateNotePayload, callback: (response: ResponseXHR<SendCandidateNoteResponse>) => void) => void
    getChangeStatus?: (data: GetChangeStatusPayload, callback: (response: ResponseXHR<GetChangeStatusStatesResponse>) => void) => void
    getNextStatusChange?: (data: GetChangeStatusPayload, callback: (response: ResponseXHR<GetChangeStatusStatesResponse>) => void) => void
    changeStatus?: (data: ChangeStatusPayload, callback: (response: ResponseXHR<ChangeStatusResponse>) => void) => void
}

export const CandidateServiceContext = createContext<CandidateServiceMock>({})

const { Provider, Consumer } = CandidateServiceContext

export interface CandidateServiceProviderProps {
    candidateService: any
}
export const CandidateServiceProvider: FC<CandidateServiceProviderProps> = ({ candidateService, children }) => (
    <Provider value={candidateService}>
        {children}
    </Provider>
)
